import { Component, Input } from '@angular/core';
import { DeepakSpinnerTestService } from '../deepak-spinner-test.service';

@Component({
  selector: 'd-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {

  @Input() card: any = '';
  @Input() loader: any = '';
  @Input() thickness!: any;

  @Input() width!: any

  @Input() primaryColor: string = '#FFFFFF';
  @Input() secondaryColor: string = '#0c7beb';

  @Input() transparencyColor: string = 'rgba(0, 0, 0, 0.4)';
 
  constructor(private spinnerService: DeepakSpinnerTestService) {}

  get showSpinner(): boolean {
    return this.spinnerService.isVisible(this.card);
  }
}
